<template>
  <transition name="fade-in-up">
    <div
      v-if="isVisible && popupMessage"
      class="notification-popup"
      :class="{'mobile-view': isMobile}"
    >
      <div class="notification-content">
        <div class="notification-header">
          <div class="notification-icon">
            <v-icon
              color="#3B7AFF"
              class="bell-shake"
            >
              mdi-bell-ring-outline
            </v-icon>
          </div>
          <div
            class="notification-title"
            style="direction:rtl"
          >
            {{ popupMessage.title }}
          </div>
          <div
            class="notification-close"
            @click="closePopup"
          >
            <v-icon size="16">
              mdi-close
            </v-icon>
          </div>
        </div>
        <div class="notification-body">
          <p>{{ popupMessage.message }}</p>
        </div>
        <div
          v-if="popupMessage.buttonText && popupMessage.buttonText.trim()"
          class="notification-footer"
        >
          <button
            class="custom-button"
            @click="handleButtonClick"
          >
            <v-icon
              left
              size="16"
              class="button-icon"
            >
              {{ getButtonIcon() }}
            </v-icon>
            <span>{{ popupMessage.buttonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { BToast } from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Vue from 'vue'
import popupMessageService from '@/services/popupMessage.service'

export default {
  name: 'AlertPopup',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BToast,
  },
  props: {
    imei: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isVisible: false,
      isMobile: Vue.prototype.$functions.isMobile(),
      popupMessage: null,
    }
  },
  async mounted() {
    await this.loadActiveMessage()
  },
  methods: {
    async loadActiveMessage() {
      try {
        const response = await popupMessageService.getActiveMessage()
        if (response.status === 'success' && response.result && response.result.data) {
          this.popupMessage = response.result.data

          // نمایش با تأخیر برای بهتر دیده شدن انیمیشن
          setTimeout(() => {
            this.isVisible = true
          }, 500)
        } else {
          // اگر پیام فعالی نیست، کامپوننت را مخفی کن
          // console.log('No active popup message found:', response)
          this.$emit('close')
        }
      } catch (error) {
        // console.error('Error loading popup message:', error)
        // در صورت خطا، کامپوننت را مخفی کن
        this.$emit('close')
      }
    },

    closePopup() {
      this.isVisible = false
      // Mark as seen (optional)
      if (this.popupMessage && this.popupMessage._id) {
        popupMessageService.markAsSeen(this.popupMessage._id).catch(err => {
          // console.warn('Failed to mark popup as seen:', err)
        })
      }
      this.$emit('close')
    },

    handleButtonClick() {
      if (!this.popupMessage) return

      switch (this.popupMessage.buttonAction) {
        case 'settings':
          this.openCommandPanel()
          break
        case 'redirect':
          this.redirectToUrl()
          break
        case 'close':
        default:
          this.closePopup()
          break
      }
    },

    openCommandPanel() {
      if (this.imei || this.$parent.selectedDevice) {
        const deviceImei = this.imei || this.$parent.selectedDevice

        // استفاده از متد onShowCommand که در هر دو کامپوننت parent موجود است
        if (typeof this.$parent.onShowCommand === 'function') {
          this.$parent.onShowCommand(deviceImei)
        } else {
          // اگر متد onShowCommand وجود نداشته باشد، سعی کنید از متد clickCommand استفاده کنید
          if (typeof this.$parent.clickCommand === 'function') {
            this.$parent.clickCommand()
          } else {
            // اگر هیچ کدام از متدها موجود نباشند، پیام را مستقیماً نمایش دهید
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'پیام',
                text: 'در حال حاضر امکان باز کردن پنل دستورات وجود ندارد.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
          }
        }

        // بستن پاپ‌آپ
        this.closePopup()
      } else {
        // در صورت عدم انتخاب دستگاه، نمایش پیام مناسب
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'لطفاً ابتدا یک دستگاه را انتخاب کنید',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
      }
    },

    redirectToUrl() {
      if (this.popupMessage && this.popupMessage.redirectUrl) {
        try {
          // اگر URL شامل http/https نیست، اضافه کن
          let url = this.popupMessage.redirectUrl
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = `https://${url}`
          }

          window.open(url, '_blank')
          this.closePopup()
        } catch (error) {
          // console.error('Error opening URL:', error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: 'خطا در باز کردن لینک',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          })
        }
      }
    },

    getButtonIcon() {
      if (!this.popupMessage) return 'mdi-cog-outline'

      const iconMap = {
        settings: 'mdi-cog-outline',
        redirect: 'mdi-open-in-new',
        close: 'mdi-close',
      }

      return iconMap[this.popupMessage.buttonAction] || 'mdi-cog-outline'
    },
  },
}
</script>

<style scoped>
.notification-popup {
  position: fixed;
  bottom: 20px;
  right: 20px; /* موقعیت پایین چپ در حالت دسکتاپ */
  z-index: 1000;
  max-width: 350px;
  width: calc(100% - 40px);
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  direction: rtl;
  background-color: #fff;
  transform: translateY(0);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.mobile-view {
  max-width: 280px;
  bottom: auto; /* حذف موقعیت پایین */
  top: 15px; /* تنظیم موقعیت بالا */
  left: 50%;
  transform: translateX(-50%); /* قرار دادن در وسط افقی */
}

.notification-content {
  display: flex;
  flex-direction: column;
}

.notification-header {
  display: flex;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.mobile-view .notification-header {
  padding: 10px;
}

.notification-icon {
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(59, 122, 255, 0.1);
}

.mobile-view .notification-icon {
  width: 30px;
  height: 30px;
  margin-left: 8px;
}

.notification-title {
  flex-grow: 1;
  font-weight: bold;
  font-size: 15px;
  color: #333;
}

.mobile-view .notification-title {
  font-size: 13px;
}

.notification-close {
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.notification-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.notification-body {
  padding: 15px;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.mobile-view .notification-body {
  padding: 10px;
  font-size: 12px;
}

.notification-footer {
  padding: 0 15px 15px;
}

.mobile-view .notification-footer {
  padding: 0 10px 10px;
}

/* استایل دکمه سفارشی */
.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 42px;
  background-color: #3B7AFF; /* رنگ آبی دکمه */
  color: white;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 2px 5px rgba(59, 122, 255, 0.3);
  padding: 0 15px;
  outline: none;
}

.mobile-view .custom-button {
  height: 36px;
  font-size: 12px;
}

.custom-button:hover {
  background-color: #2A6AEF; /* رنگ آبی تیره‌تر برای حالت هاور */
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(59, 122, 255, 0.4);
}

.custom-button:active {
  transform: translateY(0);
  background-color: #1A5ADF; /* رنگ آبی خیلی تیره‌تر برای حالت کلیک */
  box-shadow: 0 2px 3px rgba(59, 122, 255, 0.3);
}

.button-icon {
  margin-left: 8px;
  color: white !important;
}

/* انیمیشن‌ها */
.fade-in-up-enter-active, .fade-in-up-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-in-up-enter-from, .fade-in-up-leave-to {
  transform: translateY(-30px) translateX(-50%);
  opacity: 0;
}

@media (min-width: 577px) {
  .fade-in-up-enter-from, .fade-in-up-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }
}

/* سازگاری با موبایل */
@media (max-width: 576px) {
  .notification-popup {
    bottom: auto;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 30px);
    max-width: 280px;
  }

  .notification-icon {
    width: 30px;
    height: 30px;
  }

  .notification-title {
    font-size: 13px;
  }

  .notification-body {
    padding: 10px;
    font-size: 12px;
  }

  .custom-button {
    height: 36px;
    font-size: 12px;
  }
}

/* انیمیشن تکان خوردن زنگ */
.bell-shake {
  animation: bell-shake 2.5s infinite ease-in-out;
  transform-origin: top center;
}

@keyframes bell-shake {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(15deg);
  }
  3% {
    transform: rotate(-13deg);
  }
  5% {
    transform: rotate(11deg);
  }
  7% {
    transform: rotate(-9deg);
  }
  9% {
    transform: rotate(7deg);
  }
  11% {
    transform: rotate(-5deg);
  }
  13% {
    transform: rotate(3deg);
  }
  15% {
    transform: rotate(-1deg);
  }
  17% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
